<mat-drawer-container class="main-container" autosize>
	<mat-drawer *ngIf="isExist && user != null && user.userTypeDesc != 'Respondent'" #drawer class="sidenav-drawer drawer-style pt-5 rem-overflow" style="width: 112px;"
		mode="side" opened>
		<div class="menu-margin">
			<div *ngFor="let Menu of filteredMenulist;let i = index" class="item-padding font-style">
				<div *ngIf="Menu.tab != 'Business process' && Menu.tab != 'Entity' && Menu.tab != 'Admin' && Menu.tab != 'Dashboard' &&  Menu.tab != 'Dashboard summary'">
					<a  [routerLink]="Menu.navigateUrl" (click)="onClickofMenuItem($event,i)">
						<!-- <div [ngClass]="{'item-select-style':Menu.isSelected}"> -->
							<div [ngClass]="(Menu.isSelected == true) ? 'item-select-style' : 'item-hover' ">
							<img [src]="Menu.icon" alt="Menu icon" class="iconsize">				
							<br>
							<p class="item-style font">{{ Menu.tab }}</p>
						</div>										
					</a>
				</div>
				<!-- <div *ngIf="Menu.tab == 'Dashboard'">
					<a  [routerLink]="Menu.navigateUrl" (click)="onClickofMenuItem($event,i)">						
							<div [ngClass]="(Menu.isSelected == true) ? 'item-select-style' : 'item-hover' ">							
							<img [src]="Menu.icon" class="mb-3" alt="menu icon" class="iconsize"><br><span class="cascading-menu font color" >{{ Menu.tab }}</span>							
						</div>										
					</a>
				</div> -->
				<div *ngIf="Menu.tab == 'Dashboard summary'">
					<a  [routerLink]="Menu.navigateUrl" (click)="onClickofMenuItem($event,i)">						
							<div [ngClass]="(Menu.isSelected == true) ? 'item-select-style' : 'item-hover' ">									
							<img [src]="Menu.icon" class="mb-3" alt="menu icon" class="iconsize"><br><span class="cascading-menu font color" >{{ Menu.tab }}</span>							
						</div>										
					</a>
				</div>
				<div *ngIf="Menu.tab == 'Business process'">
					<div class="dropdown1" *ngIf="user.userTypeId != '6' && user.userTypeId != '3'">
						<div class="dropbtn1" style="padding:20px;" [ngClass]="{'block':bpSubMenu ,'item-select-style':Menu.isSelected}" (click)="setBpSubMenuFlag($event)">							
							<img [src]="Menu.icon" class="mb-3" alt="menu icon" class="iconsize"><br><span class="cascading-menu font color" >{{ Menu.tab }}</span>
							<div class="dropdown-content1">
								<a class="submenu" *ngIf="user.userTypeId != '3'" [routerLink]="Menu.navigateUrl" href="#"  
								   [ngClass]="{'item-select-style':isBPDashboard}" 
								   (click)="onClickofMenuItem($event,i,'isBPDashboard')"><img [src]="'assets/icons/Design.svg'" alt="Design" class="pr-3 iconzoom"><span class="pt-1">Design</span></a>
								<!-- <a class="submenu" [routerLink]="'/businessProcess'" href="#"  
								   [ngClass]="{'item-select-style': isIncidentReport}"
								   (click)="onClickofMenuItem($event,i,'isIncidentReport')">
								   <img [src]="'assets/icons/Dataentry.svg'" alt="Dataentry" class="pr-3 iconzoom">
								   <span class="pt-1">Data entry</span></a>-->
								<a class="submenu" [routerLink]="'/create/businessProcess-results'" href="#"  
									[ngClass]="{'item-select-style': isBpAnalytics}"
									(click)="onClickofMenuItem($event,i,'isBpAnalytics')"><img [src]="'assets/icons/responses.svg'" alt="responses" class="pr-3 iconzoom"><span class="pt-1">View responses</span></a> 

							
							</div>
											
						</div>
					</div>
					<div *ngIf="user.userTypeId == '6' || user.userTypeId == '3'">
						<a  [routerLink]="'/businessProcess'" (click)="onClickofMenuItem($event,i)">						
							<div [ngClass]="(Menu.isSelected == true) ? 'item-select-style' : 'item-hover' ">									
							<img [src]="'assets/icons/Dataentry.svg'" class="mb-3" alt="menu icon" class="iconsize"><br>
							<span class="cascading-menu font color" >{{ Menu.tab }}</span>							
						</div>										
					</a>
					</div>
				</div>


				<div *ngIf="Menu.tab == 'Admin'">
					<div class="dropdown1">
						<div class="dropbtn1" style="padding:20px;" [ngClass]="{'block':adminSubMenu ,'item-select-style':Menu.isSelected}" (click)="setAdminSubMenuFlag($event)">							
							<img [src]="Menu.icon" class="mb-3" alt="Menu icon" class="iconsize"><br><span class="cascading-menu font color" >{{ Menu.tab }}</span>
							<div class="dropdown-content1">
								<a class="submenu" [routerLink]="Menu.navigateUrl" href="#"  
								   [ngClass]="{'item-select-style':isManageOrg}" 
								   (click)="onClickofMenuItem($event,i,'isManageOrg')"><img [src]="'assets/icons/UserManagement.svg'" alt="Management" class="pr-3 iconzoom"><span class="pt-1">User management</span></a>
								   
								   <a class="submenu" [routerLink]="['/admin/managevalidation']" href="#"  
								   [ngClass]="{'item-select-style': isMangeValidation}"
								   (click)="onClickofMenuItem($event,i,'isManageValidation')"><img [src]="'assets/icons/Validations.svg'" alt="Validations" class="pr-3 iconzoom"><span class="pt-1">Manage validations</span></a>

								   <!-- <a class="submenu" [routerLink]="'admin/viewreport'" href="#"  
								   [ngClass]="{'item-select-style': isViewreport}"
								   (click)="onClickofMenuItem($event,i,'isViewreport')"><img [src]="'assets/icons/reports.svg'" alt="Reports" class="pr-3 iconzoom"><span class="pt-1">View reports</span></a>												
								   -->

								   <!-- <a class="submenu"
								   [ngClass]="{'item-select-style':isDashboardTableau}" 
								   (click)="tableauDashboardMenuItemClick()"><img [src]="'assets/icons/TableauReport.svg'" alt="TableauReport" class="pr-3 iconzoom"><span class="pt-1" style="width: 188px !important;">Advanced Incident Summary</span></a> -->

								   <a class="submenu" [routerLink]="['/admin/viewreport']" href="#"  
								   [ngClass]="{'item-select-style': isViewreport}"
								   (click)="onClickofMenuItem($event,i,'isViewreport')"><img [src]="'assets/icons/reports.svg'" alt="Reports" class="pr-3 iconzoom"><span class="pt-1">View reports</span></a>

								   <a class="submenu" [routerLink]="['/admin/resource-upload']" href="#"  
								   
								   (click)="onClickofMenuItem($event,i,'isResourceUpload')"><img [src]="'assets/icons/reports.svg'" alt="Reports" class="pr-3 iconzoom"><span class="pt-1">Resource Upload</span></a>

								   <a class="submenu"
									[routerLink]="['/admin/sync']"
									href="#"
									(click)="onClickofMenuItem($event,i)">
										<img [src]="'assets/icons/reports.svg'" alt="Sync" class="pr-3 iconzoom">
										<span class="pt-1">Sync to Scoring</span>
									</a>

								</div>
											
						</div>
					</div>
				</div>
				<div *ngIf="Menu.tab == 'Entity'">
					<div class="dropdown1">
						<div class="dropbtn1" style="padding:20px;" [ngClass]="{'block':entitySubMenu ,'item-select-style':Menu.isSelected}" (click)="setEntitySubMenuFlag($event)">							
							<img [src]="Menu.icon" class="mb-3" alt="Menu icon" class="iconsize"><br><span class="cascading-menu font color" >{{ Menu.tab }}</span>
							<div class="dropdown-content1">
								<a class="submenu" *ngIf="user.userTypeId != '3'" [routerLink]="Menu.navigateUrl" href="#"  
								[ngClass]="{'item-select-style':isEntityDashboard}" 
								(click)="onClickofMenuItem($event,i,'isEntityDashboard')"><img [src]="'assets/icons/Design.svg'" alt="Design" class="pr-3 iconzoom"><span class="pt-1">Design</span></a>
								<a class="submenu"  *ngIf="user.userTypeId == '1' || user.userTypeId == '5'" [routerLink]="'/supervisor-mapping'" href="#"  
								   [ngClass]="{'item-select-style':isMappingEntity}" 
								   (click)="onClickofMenuItem($event,i,'isMappingEntity')"><img [src]="'assets/icons/security.svg'" alt="Security" class="pr-3 iconzoom"><span class="pt-1">Advanced security</span></a>
								
							</div>
											
						</div>
					</div>
				</div>				

				
				
		    </div>
		</div>
	
	</mat-drawer>
	<mat-drawer-content class="pb-0 pt-2" style="overflow: unset !important;">
		<router-outlet></router-outlet>
	</mat-drawer-content>
</mat-drawer-container>